import { from } from 'rxjs'
import { catchError, concatMap, filter, map, switchMap } from 'rxjs/operators'
import { errorNotification, successNotification, OpenIddictApplicationService } from '~/Services'
import { ModalName as ProductModalName, ProductActions } from '~/Store/Products'
import { RootEpic } from '../types'
import { OpenIddictApplicationActions } from './slice'

const getApplicationsEpic: RootEpic = action$ =>
  action$.pipe(
    filter(OpenIddictApplicationActions.getApplications.match),
    switchMap(() =>
      from(OpenIddictApplicationService.Get.getAll()).pipe(
        map(res => OpenIddictApplicationActions.getApplicationsSuccess(res.data)),
        catchError(error => {
          errorNotification(error)
          return [OpenIddictApplicationActions.getApplicationsFail()]
        }),
      ),
    ),
  )

const createApplicationEpic: RootEpic = action$ =>
  action$.pipe(
    filter(OpenIddictApplicationActions.createApplication.match),
    switchMap(action =>
      from(OpenIddictApplicationService.Post.create(action.payload)).pipe(
        // Application + Product được tạo cùng lúc bằng 1 request (identity-service tự tạo Product theo
        // ClientId) — Create chỉ còn được gọi từ popup của tab Product (Applications không còn tab riêng),
        // nên đóng luôn modal Product và refetch danh sách Product ở đây.
        concatMap(() => {
          successNotification('Tạo sản phẩm thành công!')
          return [
            OpenIddictApplicationActions.createApplicationSuccess(),
            OpenIddictApplicationActions.getApplications(),
            ProductActions.getProducts(),
            ProductActions.setModalVisibility({
              name: ProductModalName.Product,
              visible: false,
            }),
          ]
        }),
        catchError(error => {
          errorNotification(error, 'Tạo sản phẩm thất bại')
          return [OpenIddictApplicationActions.createApplicationFail()]
        }),
      ),
    ),
  )

const updateApplicationEpic: RootEpic = action$ =>
  action$.pipe(
    filter(OpenIddictApplicationActions.updateApplication.match),
    switchMap(action => {
      const { id, data } = action.payload
      return from(OpenIddictApplicationService.Put.update(id, data)).pipe(
        concatMap(() => {
          successNotification('Cập nhật ứng dụng thành công!')
          return [
            OpenIddictApplicationActions.updateApplicationSuccess(),
            OpenIddictApplicationActions.getApplications(),
          ]
        }),
        catchError(error => {
          errorNotification(error, 'Cập nhật ứng dụng thất bại')
          return [OpenIddictApplicationActions.updateApplicationFail()]
        }),
      )
    }),
  )

const deleteApplicationEpic: RootEpic = action$ =>
  action$.pipe(
    filter(OpenIddictApplicationActions.deleteApplication.match),
    switchMap(action =>
      from(OpenIddictApplicationService.Delete.delete(action.payload)).pipe(
        concatMap(() => {
          successNotification('Xóa ứng dụng thành công!')
          return [
            OpenIddictApplicationActions.deleteApplicationSuccess(),
            OpenIddictApplicationActions.getApplications(),
          ]
        }),
        catchError(error => {
          errorNotification(error, 'Xóa ứng dụng thất bại')
          return [OpenIddictApplicationActions.deleteApplicationFail()]
        }),
      ),
    ),
  )

const uploadLogoEpic: RootEpic = action$ =>
  action$.pipe(
    filter(OpenIddictApplicationActions.uploadLogo.match),
    switchMap(action => {
      const { id, file } = action.payload
      return from(OpenIddictApplicationService.UploadLogo(id, file)).pipe(
        map(res => {
          successNotification('Cập nhật logo thành công!')
          return OpenIddictApplicationActions.logoActionSuccess(res.data)
        }),
        catchError(error => {
          errorNotification(error, 'Cập nhật logo thất bại')
          return [OpenIddictApplicationActions.logoActionFail()]
        }),
      )
    }),
  )

const removeLogoEpic: RootEpic = action$ =>
  action$.pipe(
    filter(OpenIddictApplicationActions.removeLogo.match),
    switchMap(action =>
      from(OpenIddictApplicationService.Delete.deleteLogo(action.payload)).pipe(
        map(res => {
          successNotification('Đã gỡ logo!')
          return OpenIddictApplicationActions.logoActionSuccess(res.data)
        }),
        catchError(error => {
          errorNotification(error, 'Gỡ logo thất bại')
          return [OpenIddictApplicationActions.logoActionFail()]
        }),
      ),
    ),
  )

export const OpenIddictApplicationEpics = [
  getApplicationsEpic,
  createApplicationEpic,
  updateApplicationEpic,
  deleteApplicationEpic,
  uploadLogoEpic,
  removeLogoEpic,
]
